/**
 * Iconos SVG inline para la Calculadora BCV.
 * Heredan el color del texto (`currentColor`) y aceptan `...props`
 * (className, style, width, height, etc.).
 */

export const CalculatorIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect x="5" y="2.5" width="14" height="19" rx="2.5" />
    <line x1="8" y1="6.5" x2="16" y2="6.5" />
    <line x1="8.5" y1="11" x2="8.51" y2="11" />
    <line x1="12" y1="11" x2="12.01" y2="11" />
    <line x1="15.5" y1="11" x2="15.51" y2="11" />
    <line x1="8.5" y1="14.5" x2="8.51" y2="14.5" />
    <line x1="12" y1="14.5" x2="12.01" y2="14.5" />
    <line x1="15.5" y1="14.5" x2="15.51" y2="14.5" />
    <line x1="8.5" y1="18" x2="8.51" y2="18" />
    <line x1="12" y1="18" x2="12.01" y2="18" />
    <line x1="15.5" y1="18" x2="15.51" y2="18" />
  </svg>
);

export const CloseIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <line x1="6" y1="6" x2="18" y2="18" />
    <line x1="18" y1="6" x2="6" y2="18" />
  </svg>
);

export const CalendarIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect x="3" y="4.5" width="18" height="16" rx="2.5" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="8" y1="2.5" x2="8" y2="6" />
    <line x1="16" y1="2.5" x2="16" y2="6" />
  </svg>
);

export const CoinIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M12 6.5v11" />
    <path d="M14.8 9.2a2.6 2.6 0 0 0-2.8-1.7c-1.6 0-2.8.9-2.8 2.2 0 1.3 1.1 1.9 2.8 2.3 1.7.4 2.8 1 2.8 2.3 0 1.3-1.2 2.2-2.8 2.2a2.6 2.6 0 0 1-2.8-1.7" />
  </svg>
);

export const CopyIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

export const CheckIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const ChevronRightIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <polyline points="9 6 15 12 9 18" />
  </svg>
);
